<template>
<div class="container">
    <div class="row">
        <div id="title" class="col-12 col-md-8">
            <h3>每月度數查詢</h3>
            <router-link :to="{ name: 'Main', params: { id: this.id }}">回首頁</router-link>
        </div>
        <div id="select" class="col-12 col-md-4">
            <h6>選取年</h6>
            <input type="text" class="form-control" v-model="selectedYear" readonly>
            <button class="btn btn-outline-dark" @click="addYear(-1)">上一年</button>
            <button class="btn btn-outline-dark" @click="addYear(1)">下一年</button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <flot-bar-chart :average='this.average' :ymax='this.flotMax' :xaxis='this.flotXAxis' :data='this.flotData' :averageData='this.flotAverageData' :tickSize='200'></flot-bar-chart>
        </div>
    </div>
</div>
</template>

<script>
import FlotBarChart from '@/components/FlotBarChart';

export default {
    name: 'BarYear',
    components: {
        FlotBarChart,
    },
    data() {
        return {
            id: '',
            selectedYear: '',
            flotData: '',
            flotAverageData: '',
            flotXAxis: '',
            flotMax: '',
            average: ''
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.defaultYear();
    },
    mounted() {
        this.getData();
    },
    methods: {
        defaultYear: function () {
            var today = new Date();
            this.selectedYear = today.getFullYear();
        },
        addYear: function (x) {
            var temp = this.selectedYear + x;
            this.selectedYear = temp;
            this.getData();
        },
        getData: function () {
            var year = this.selectedYear;
            var api_url = process.env.VUE_APP_SOALR_URL + `/api/solar/daily/${this.id}/${year}`;
            let self = this;

            this.$http
                .get(api_url)
                .then(res => {
                    const data = res.data;

                    self.flotData = data.data;
                    self.flotAverageData = data.average.avgArray;
                    self.flotXAxis = data.xAxis;
                    self.flotMax = Math.ceil(data.totalWatt * 7 * 25);
                    self.average = data.average.average;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/bar.scss";
</style>
